module.exports = __webpack_public_path__ + "img/backgroundImage.59011534.jpg";